export const INITIAL_STATE: any = {
  location: {
    ip: undefined,
    selected: null,
    isMatchingVat: null,
  },
  order: {
    token: '',
    url: '',
    button: { price: '' },
    cart: {
      discount: {},
      product: {},
      tax: {},
      total: { price: 'SOME charge' },
    },
  },
  metadata: {},
  stripe: {
    api: null,
    card: {
      handleCardAction: true,
      handleCardSetup: true,
      getToken: true,
      createPaymentMethod: true,
    },
    isReady: false,
    hasBeenModified: false,
  },
  ui: {
    elements: {},
    hasPaymentBeenSubmitted: false,
    htmlForms: {},
    shouldPreventSubmit: true,
  },
  user: {
    stripe_temporary_token: undefined,
    stripe_payment_method_id: undefined,
    stripe_payment_intent_id: undefined,
    country_code_confirmation: undefined,
    mobile_payment_method_name: undefined,
  },
}
